module.exports = __webpack_public_path__ + "7ccee99a15be40c1eb224246d8092696.svg";